module.exports = __webpack_public_path__ + "img/section1_img1.1c44ffa2.png";